import * as React from "react";
import { useData, useDataValue } from "../hooks/useData";
import { closestKey } from "../utils/dom";
import { toNumber } from "../utils/conversion";



// stored as: yyyy-dd-mm

export function Date(props: {
	className?: string,

	prop: string,

	disabled?: boolean,

	onChange?: (e: any, value: Date) => void;

}) {

    const {
        className,
        prop,
    } = props;

	const data = useData();
	const value = useDataValue(data, prop);

	let day = "", month = "", year = "";
	if (value) {
		const parts = value.split("-");
		if (parts.length >= 1) year = String(toNumber(parts[0], 0));
		if (parts.length >= 2) month = String(toNumber(parts[1], 0));
		if (parts.length >= 3) day = String(toNumber(parts[2], 0));
		if (year === "0") year = "";
		if (month === "0") month = "";
		if (day === "0") day = "";
	}

	function composeDate() {
		// value needs to be saved with correct padding
		if (year.length > 0) while (year.length < 4) year = "0" + year;		
		if (month.length > 0) while (month.length < 2) month = "0" + month;		
		if (day.length > 0) while (day.length < 2) day = "0" + day;
		const result = year + "-" + month + "-" + day;
		if (result === "--") {
			return "";
		} else {
			return result;
		}
	}

    function handleInputChange(e: any) {
        const key = closestKey(e.target, ".form-control");
        if (!key) return;

        const val = e.target.value;

        if (key === "day") {
            day = val;
        } else if (key === "month") {
            month = val;
        } else if (key === "year") {
            year = val;
        }

		data.setValue(prop, composeDate());
    }

    return (
        <div
            className={[className, "date-parts"].join(" ")}
        >
            <input
                className={[className, "form-control text-center day"].join(" ")}
                data-key="day"
                placeholder="d"
                value={day}
                maxLength={2}
                onChange={handleInputChange}
				style={{width:"30px"}}
            />
            <span className="separator padding-3">/</span>
            <input
                className={[className, "form-control text-center month"].join(" ")}
                data-key="month"
                placeholder="m"
                value={month}
                maxLength={2}
                onChange={handleInputChange}
				style={{width:"30px"}}
            />
            <span className="separator padding-3">/</span>
            <input
                className={[className, "form-control text-center year"].join(" ")}
                data-key="year"
                placeholder="yyyy"
                value={year}
                maxLength={4}
                onChange={handleInputChange}
				style={{width:"60px"}}
            />
        </div>
    );


}

